import { HeaderContainer as Header } from '../HeaderTemplate/HeaderContainer';
import { BurgerMenuContainer } from './BurgerMenuContainer';
import { Navigation } from './Navigation';
/**
 * Header containing the navigation links
 */
export const HeaderFull = () => (
  <Header Navigation={<Navigation />} TopLeftButton={<BurgerMenuContainer />} />
);
